/* eslint-disable */
import React, { useState, useContext, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Checkbox, FormControlLabel, TextareaAutosize, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import DropZone from '../../Components/DropZone';
import PageLayout from '../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../../Assets/svg/CityIcon.svg";
import { ReactComponent as FilterIcon } from "../../Assets/svg/FilterIcon.svg";
import { ReactComponent as NotificationIcon } from "../../Assets/svg/NotificationIcon.svg";
import { ReactComponent as PersonList } from "../../Assets/svg/PersonList.svg";
import { ReactComponent as DownloadIcon } from "../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as ShieldIcon } from "../../Assets/svg/ShieldIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as MapMarkerIcon } from "../../Assets/svg/MapMarkerIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
import { PropertyContext } from '../../context/property-context';
import data from '../../api/melkData.json';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
import {
    useParams
} from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ButtonNavigation from '../../Components/ButtonNavigation';
import PropItem from '../../Components/PropItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { useSearchPropStore } from '../../store/searchProperty';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import InfiniteScroll from "react-infinite-scroll-component";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import useForceUpdate from 'use-force-update';
import { useUserStore } from '../../store/user';
import moment from "moment-jalaali"
import Cookies from 'js-cookie'
import { InView } from 'react-intersection-observer';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};





function Filing(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [tabValue, setTabValue] = React.useState(0);
    const [openZoneModal, setOpenZoneModal] = React.useState(false);
    const [openTypeZone, setOpenTypeZone] = React.useState(false);
    const [areasItems, setAreasItems] = React.useState([]);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [salePriceModal, setSalePriceModal] = React.useState(false);
    const [rentPriceModal, setRentPriceModal] = React.useState(false);
    const [rahnPriceModal, setRahnPriceModal] = React.useState(false);
    const [tmpRentPriceModal, setTmpRentPriceModal] = React.useState(false);
    const [tmpRahnPriceModal, setTmpRahnPriceModal] = React.useState(false);
    const [tmpSalePriceModal, setTmpSalePriceModal] = React.useState(false);
    const [selectMeterModal, setSelectMeterModal] = React.useState(false);
    const [selectSpaceModal, setSelectSpaceModal] = React.useState(false);

    const [typeZone, setTypeZone] = React.useState(1);

    const [openStatus, setOpenStatus] = React.useState(false);

    const [melkTypeModal, setMelkTypeModal] = React.useState(false);
    const [showPriceItem, setShowPriceItem] = React.useState(0);
    const [showMeterItem, setShowMeterItem] = React.useState(0);
    const [melkTabValue, setMelkTabValue] = React.useState(0);
    const [openSelectTypeModal, setOpenSelectTypeModal] = React.useState(false);
    const [showYearItem, setShowYearItem] = React.useState(false);
    const [selectYearModal, setSelectYearModal] = React.useState(false);
    const [nowDate, setNowDate] = React.useState("");
    const [yearDates, setYearDates] = React.useState([]);
    const [openSanadModal, setOpenSanadModal] = React.useState(false);
    const [openSearchTypeModal, setOpenSearchTypeModal] = React.useState(false);
    const [openUserTypeModal, setOpenUserTypeModal] = React.useState(false);
    const [openMapModal, setOpenMapModal] = React.useState(false);
    const [showSearchType, setShowSearchType] = React.useState('');
    const [changeFlag, setChangeFlag] = React.useState(false);
    const [filingDescriptionModal, setFilingDescriptionModal] = React.useState(false);
    const [MinSalePrice, setMinSalePrice] = React.useState("");
    const [MaxSalePrice, setMaxSalePrice] = React.useState("");
    const [MinRentPrice, setMinRentPrice] = React.useState("");
    const [MaxRentPrice, setMaxRentPrice] = React.useState("");
    const [MinMortgagePrice, setMinMortgagePrice] = React.useState("");
    const [MaxMortgagePrice, setMaxMortgagePrice] = React.useState("");
    const [moreSearchDataTmp, setMoreSearchDataTmp] = React.useState({});
    const [filingStat, setFilingStat] = React.useState({});

    const positionMap = [36.32386694335946, 59.579383705135136]


    const [hasMore, setHasMore] = React.useState(true);
    const [propLoading, setPropLoading] = React.useState(false);
    const [ofsset, setOfsset] = React.useState(0);
    const dataFetchedRef = useRef(false);
    const [properties, setProperties] = React.useState([]);
    const [propKey, setPropKey] = React.useState(0);

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const locationId = useUserStore((state) => state.locationId)


    const navigation = useNavigate();
    const forceUpdate = useForceUpdate();

    const searchData = useSearchPropStore((state) => state.searchData)
    const setSearchData = useSearchPropStore((state) => state.setSearchData)
    const emptySearchData = useSearchPropStore((state) => state.emptySearchData)
    const [properInPlusing, setProperInPlusing] = React.useState(true);

    const searchType = searchData.SearchType
    const limit = searchData.Limit



    const handleStatusModalClick = () => {
        setOpenStatus(true);
    };

    const handleStatusModalClose = () => {
        setOpenStatus(false);
    };

    const handlefilingDescriptionModalClick = () => {
        setFilingDescriptionModal(true);
    };

    const filingDescriptionModalClose = () => {
        setFilingDescriptionModal(false);
    };



    const handleClickSearchTypeModal = () => {
        setOpenSearchTypeModal(true);
    };

    const handleSearchTypeModalClose = () => {
        setOpenSearchTypeModal(false);
    };

    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);

        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleZoneModalClose = () => {
        setOpenZoneModal(false);
    };

    const handleOpenTypeZoneClose = () => {
        setOpenTypeZone(false);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClickTypeZone = () => {
        setOpenTypeZone(true);
    };

    const handleClickRentPriceModal = () => {
        setRentPriceModal(true);
    };

    const handleSaleRentModalClose = () => {
        setRentPriceModal(false);
    };

    const handleClickRahnPriceModal = () => {
        setRahnPriceModal(true);
    };

    const handleSaleRahnModalClose = () => {
        setRahnPriceModal(false);
    };

    const handleClickTmpRentPriceModal = () => {
        setTmpRentPriceModal(true);
    };

    const handleSaleTmpRentModalClose = () => {
        setTmpRentPriceModal(false);
    };

    const handleClickTmpRahnPriceModal = () => {
        setTmpRahnPriceModal(true);
    };

    const handleSaleTmpRahnModalClose = () => {
        setTmpRahnPriceModal(false);
    };

    const handleClickSalePriceModal = () => {
        setSalePriceModal(true);
    };

    const handleSalePriceModalClose = () => {
        setSalePriceModal(false);
    };

    const handleClickTmpSalePriceModal = () => {
        setTmpSalePriceModal(true);
    };

    const handleSaleTmpSalePriceModalClose = () => {
        setTmpSalePriceModal(false);
    };

    const handleClickSelectMeterModal = () => {
        setSelectMeterModal(true);
    };

    const handleSelectMeterModalClose = () => {
        setSelectMeterModal(false);
    };

    const handleClickSelectSpaceModal = () => {
        setSelectSpaceModal(true);
    };

    const handleSelectSpaceSpaceClose = () => {
        setSelectSpaceModal(false);
    };

    const handleClickSelectYearModal = () => {
        setSelectYearModal(true);
    };

    const handleSelectYearModalClose = () => {
        setSelectYearModal(false);
    };



    const handleMelkTypeClose = () => {
        setMelkTypeModal(false);
    };

    const handleClickSelectTypeModal = () => {
        setOpenSelectTypeModal(true);
    };

    const handleSelectTypeModalClose = () => {
        setOpenSelectTypeModal(false);
    };

    const handleTabChange = (event, newValue) => {
        console.log("newValue", newValue)
        setTabValue(newValue);
    };

    const handleChangeMelkTabValue = (event, newValue) => {
        console.log("newValue", newValue)
        setMelkTabValue(newValue);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleClickOpenSanadModal = () => {
        setOpenSanadModal(true);
    };
    const handleCloseSanadModal = () => {
        setOpenSanadModal(false);
    };

    const handleClickOpenUserTypeModal = () => {
        setOpenUserTypeModal(true);
    };

    const handleCloseOpenUserTypeModal = () => {
        setOpenUserTypeModal(false);
    };


    const handleClickOpenMapModal = () => {
        setOpenMapModal(true);
    };
    const handleCloseMapModal = () => {
        setOpenMapModal(false);
    };



    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {

            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 40);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    useEffect(() => {
        console.log("offset use")

        if (hasMoreOffset && areasItems.length) {
            if (typeZone == "1")
                getAreas(false, "", "/areas/list")
            if (typeZone == "2")
                getAreas(false, "", "/webapp/divar_areas/list")
        }
    }, [areaOfsset])


    useEffect(() => {
        console.log("typeZone", typeZone)
        if (typeZone == "1")
            getAreas(true, "", "/areas/list")
        if (typeZone == "2")
            getAreas(true, "", "/webapp/divar_areas/list")


    }, [typeZone])

    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
        }

        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),

            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 40
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 1000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }
    ///////////////////////

    const [boughtFiles, setBoughtFiles] = useState([])
    const handleBuyingFiles = (id) => {

        let tmpBoughtFiles = [...boughtFiles]

        tmpBoughtFiles.push(id)
        setBoughtFiles(tmpBoughtFiles)

        console.log("boughtFiles", boughtFiles)
    }

    useEffect(() => {
        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        for (let i = parseInt(now); i >= parseInt(now) - 51; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }

        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/divar/posts-count",
                method: "POST",
                data: {
                    "LocationId": locationId.toString(),
                }
            }).then((res) => {
                console.log("divar", res)
                setFilingStat(res.data.result)
            })
        } catch (e) {
            console.error(e);

        }

        getAreas()

    }, [])

    useEffect(() => {
        if (searchType == 'Sale')
            setShowSearchType('خرید')
        if (searchType == 'Rent')
            setShowSearchType('اجاره')
        if (searchType == 'Exchange')
            setShowSearchType('معاوضه')
        if (searchType == 'SalePreSale')
            setShowSearchType('پیش خرید')
        if (searchType == 'Associate')
            setShowSearchType('مشارکت')

        console.log("searchTypeeee", searchType)
    }, [searchType])

    const areasSearchHandle = async (e) => {
        handleToggleBackdrop()
        if (e.target.value != "") {
            if (typeZone == "1")
                getAreas(true, e.target.value, "/areas/list")
            if (typeZone == "2")
                getAreas(true, e.target.value, "/webapp/divar_areas/list")
        } else {
            if (typeZone == "1")
                getAreas(true, "", "/areas/list")
            if (typeZone == "2")
                getAreas(true, "", "/webapp/divar_areas/list")
        }
    }

    const setSearchTypeHandle = (typeName, typeValue) => {
        console.log(typeName, typeValue)
        const newState = { name: typeName, value: typeValue }
        setChangeFlag(true)
        console.log("newState", newState)
        setSearchData(newState);
        setOpenSearchTypeModal(false)
    }

    const handleSetSalePrice = (isEpty = false) => {
        isEpty && emptySearchData()
        setChangeFlag(true)
        setSearchData({ name: "MinSalePrice", value: MinSalePrice });
        setSearchData({ name: "MaxSalePrice", value: MaxSalePrice });
        handleSalePriceModalClose()
    }

    const handleRentPrice = (isEpty = false) => {
        console.log("rent")
        isEpty && emptySearchData()
        setChangeFlag(true)
        setSearchData({ name: "MinRentPrice", value: MinRentPrice });
        setSearchData({ name: "MaxRentPrice", value: MaxRentPrice });
        handleRentPriceModalClose()
    }

    const handleRahnPrice = () => {
        setChangeFlag(true)
        setSearchData({ name: "MinMortgagePrice", value: MinMortgagePrice });
        setSearchData({ name: "MaxMortgagePrice", value: MaxMortgagePrice });
        handleSaleRahnModalClose()
    }

    const PropertyAreaHandle = (e) => {
        // emptySearchData()
        setChangeFlag(true)
        setSearchData({ name: "Areas", value: [e.target.value] });
        handleZoneModalClose()
    }






    const handleFilterByIsBought = (target) => {
        if (target == "NotIsBought") {
            setSearchData({ name: "IsBought", value: "0" });
            setChangeFlag(true)
            setSearchData({ name: "NotIsBought", value: "1" });
        }

        if (target == "IsBought") {
            setSearchData({ name: "NotIsBought", value: "0" });
            setChangeFlag(true)
            setSearchData({ name: "IsBought", value: "1" });
        }

        handleStatusModalClose()

    }


    const getProperties = (resetState = false) => {
        // console.log("searchDataaaa", searchData)
        if (resetState) {
            setProperties([])
            console.log("reset", properties)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setPropLoading(true)
        var searchItems = {}
        for (const item in searchData) {
            if (searchData[item] != "" && item != "AgencyId" && item != "WithSubAgencyProperties") {
                searchItems[item] = searchData[item]
            }
        }
        searchItems["Offset"] = ofsset
        searchItems["FromDivar"] = "1"

        searchItems["LandLordInfo"] = true

        console.log("searchItems", searchItems)
        if (locationId)
            searchItems["LocationId"] = locationId
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/properties/get/list/by/filter",
                method: "POST",
                data: searchItems,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("propres", res.data.result.Properties);

                const tmpProp = [...properties]
                if (res.data.result.Properties.length > 0) {
                    if (!resetState) {
                        res.data.result.Properties.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setProperties(tmpProp)
                        console.log("resetState not")
                    }
                    else
                        setProperties(res.data.result.Properties)

                    console.log("proper", properties)

                    setPropKey(propKey => propKey++)
                } else {
                    console.log("End")
                    setHasMore(false)
                    if (resetState) setProperties([])

                }
                setPropLoading(false)
                setChangeFlag(false)
                setTimeout(function () { setProperInPlusing(true) }, 1000)
                setTimeout(function () {
                    Array.from(document.querySelectorAll(".dash-property-item")).forEach(
                        (ele) => {
                            console.log("ele", ele)
                            ele.addEventListener("contextmenu", (e) => { e.preventDefault() });
                        })
                }, 1000)
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
            setChangeFlag(false)
        }


    }

    // const onScroll = () => {
    //     if (document.getElementById("dashboard-content")) {
    //         const scrollTop = document.getElementById("dashboard-content").scrollTop
    //         const scrollHeight = document.getElementById("dashboard-content").scrollHeight
    //         const clientHeight = document.getElementById("dashboard-content").clientHeight
    //         if (scrollTop + clientHeight >= scrollHeight && properInPlusing) {
    //             setProperInPlusing(false)
    //             setOfsset(ofsset => ofsset + limit);
    //             // setSearchData({"name":"Offset","value":ofsset})
    //             console.log("ofsset", ofsset)
    //         }
    //     }
    // }

    // useEffect(() => {
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && properties.length > 0) {
    //             document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
    //             return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
    //         }
    //     }, 500)
    // }, [properties])

    const handlePlusPropOffset = (inView) => {
        console.log("🚀 ~ handlePlusPropOffset ~ inView:", inView)

        if (inView && !propLoading && hasMore) {
            setOfsset(ofsset => ofsset + limit);
        }
    }

    useEffect(() => {
        console.log("offset use")

        if (hasMore && properties.length) {
            getProperties()
        }
    }, [ofsset])



    useEffect(() => {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // emptySearchData()




        getProperties()





    }, [])

    useEffect(() => {
        if (changeFlag) {
            getProperties(true)
            console.log('run use efect')
        }
    }, [searchData])

    const handleSetDate = (date, format = 'YYYY/MM/DD') => {
        let object = { date, format }

        var dateSelected = new DateObject(object).convert(persian, persian_en).format()

        var miladiDate = moment(dateSelected, 'jYYYY/jM/jD').format('YYYY-M-D')
        console.log(miladiDate)
        var d = new Date(miladiDate)

        const tmp = { ...moreSearchDataTmp }
        tmp["MinRegisterDate"] = d.getTime() / 1000
        setMoreSearchDataTmp(tmp)
    }

    const handleSetMoreSearchDataTmp = (searchItem, value, isArray = false, isAppend = false, isToggle = false) => {
        const tmp = { ...moreSearchDataTmp }

        if (isAppend) {
            !tmp[searchItem] ? tmp[searchItem] = [] : null
            if (tmp[searchItem].includes(value)) {
                const index = tmp[searchItem].indexOf(value);
                const newItem = tmp[searchItem].filter((item, index) => item != value);
                console.log("newItem", newItem)
                tmp[searchItem] = newItem
            } else {
                tmp[searchItem].push(value)
            }

        } else {
            if (!isArray) {
                if (!isToggle)
                    tmp[searchItem] = value
                else {
                    if (tmp[searchItem].includes(value)) {
                        const index = tmp[searchItem].indexOf(value);
                        const newItem = tmp[searchItem].filter((item, index) => item != value);
                        console.log("newItem", newItem)
                        tmp[searchItem] = newItem
                    } else {
                        tmp[searchItem] = [value]
                    }
                }
            }
            else tmp[searchItem] = [value]
        }

        setMoreSearchDataTmp(tmp)
        console.log("moreSearchDataTmp", moreSearchDataTmp)
        handleSaleTmpSalePriceModalClose()
    }

    const handlBooleanMoreSearchDataTemp = (searchItem, value) => {
        const tmp = { ...moreSearchDataTmp }

        if (tmp[searchItem] == "1") {
            tmp[searchItem] = "0"
            console.log("exits")
        }
        else {
            tmp[searchItem] = "1"
            console.log("not exits", searchItem)
        }
        setMoreSearchDataTmp(tmp)

        console.log("moreSearchDataTmp", moreSearchDataTmp)

    }
    const [openCollapse, setOpenCollapse] = React.useState(true);


    const shield = <Button className='rounded-50' sx={{ display: 'flex', gap: '5px' }} onClick={handlefilingDescriptionModalClick}>
        <ShieldIcon />
    </Button>

    return (
        <>
            <PageLayout title='' rightHeaderItem={shield} key={propKey}>
                <Box id="dashboard-content" sx={{ pt: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        className='tab-nav'
                        dir="rtl"
                    >
                        <Tab label="وضعیت" className='tab-nav-item' onClick={handleStatusModalClick} />
                        <Tab label={showSearchType} className='tab-nav-item' onClick={handleClickSearchTypeModal} />
                        <Tab label="محدوده" className='tab-nav-item' onClick={handleClickOpenZoneModal} />
                    </Tabs>
                    <Collapse in={openCollapse} sx={{ px: 3, my: 1 }}>
                        <Box

                            sx={{ bgcolor: "transparent", border: "solid 1px #B1B1B1", borderRadius: "5px" }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
                                <Box>تعداد فایل های ملکی دریافتی از پایش در شهر <Typography component="span" sx={{ color: "#29A19C" }}>{userInfo.LocationName}</Typography></Box>
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenCollapse(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            </Box>
                            {
                                Object.keys(filingStat).length ?
                                    <Box sx={{ my: 1, px: 3, display: "flex", flexDirection: 'column', gap: "10px" }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", width: '100%' }}>
                                            <Box>امروز</Box>
                                            <Box>{filingStat.today_tokens}</Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", width: '100%' }}>
                                            <Box>دیروز</Box>
                                            <Box>{filingStat.yesterday_tokens}</Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", width: '100%' }}>
                                            <Box>تعداد کل</Box>
                                            <Box>{filingStat.total_tokens}</Box>
                                        </Box>
                                    </Box> : ""
                            }
                        </Box>
                    </Collapse>
                    <Box sx={{ px: 3, py: 1 }} >
                        {
                            properties && properties.length > 0 ?
                                properties.map((item, index) => (
                                    <PropItem key={index} propInfo={item} fromFiling={true} handleBuyingFiles={handleBuyingFiles} boughtFiles={boughtFiles} />
                                ))
                                : !propLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                        }
                        {
                            propLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                        }
                        <InView
                            as='div'
                            onChange={(inView, entry) =>
                                handlePlusPropOffset(inView, entry)
                            }></InView>
                    </Box>
                </Box>
                <ButtonNavigation />

            </PageLayout >






            <Dialog className="dialog-box"
                fullScreen
                open={openStatus}
                onClose={handleStatusModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        <IconButton>
                            <SettingIcon />
                        </IconButton>
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>

                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleStatusModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                    <Box>
                        <input type="radio" name='statusProp' id="myOptions" value="IsBought" className="d-none typeCheck" onChange={(e) => handleFilterByIsBought(e.target.value)} />
                        <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                            خریداری شده
                        </label>
                    </Box>
                    <Box>
                        <input type="radio" name='statusProp' id="daryafti" value="NotIsBought" className="d-none typeCheck" onChange={(e) => handleFilterByIsBought(e.target.value)} />
                        <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                            خریداری نشده
                        </label>
                    </Box>

                </Box>
                <Button className='green-btn' onClick={handleStatusModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
            </Dialog>

            <Dialog className="dialog-box"
                fullScreen
                open={filingDescriptionModal}
                onClose={filingDescriptionModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>

                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={filingDescriptionModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, px: 3 }}>
                    <Box sx={{ color: '#096767', fontWeight: 'bold' }}>فایلینگ ومساله خط ومشی رازداری</Box>
                    <Box>
                        در زمان استفاده از سامانه مدیریت املاک پایش، اطلاعات شما
                        همواره محفوظ خواهد بود. اطلاعات ملکی که توسط شما در
                        پایش ثبت شده به هیچ عنوان توسط پایش در بخش فایلینگ
                        استفاده نخواهد شد.  دسترسی به اطلاعات شما صرفا توسط
                        خودتان با ارائه شماره همراه ثبت نامی امکان پذیر می باشد
                        از حیث فنی سامانه با امنیت بالایی پیاده سازی شده است
                        بطوری که سایر اشخاص نمی توانند به اطلاعات دسترسی
                        پیدا کنند
                        افراد مختلف نگرانی‌های متفاوتی در ارتباط با اطلاعات خود
                        دارند. هدف ما این است که در ارتباط با اطلاعاتی که ثبت می
                        کنید، بصورت شفاف عمل کنیم تا شما بتوانید درباره نحوه
                        استفاده از آنها انتخاب‌های معناداری داشته باشید
                        ربات هوشمند فایلینگ پایش اطلاعات خود را از سایت های
                        مشهور ایران جمع آوری می کند، و در این خصوص کاربر پس
                        از عضویت در فایلینگ خواهد توانست راستی آزمایی کند. ما
                        همچنان همانند سالیان گذشته متعهد به حفظ اطلاعات کاربران
                        خود هستیم. دریافت سه مجوز فناور از پارک علم و فناوری
                        طی این سالها خود گویای رویکرد حرفه ای ما در این خصوص
                        می باشد
                    </Box>
                </Box>

            </Dialog>

            <Dialog className="dialog-box"
                fullScreen
                open={openSearchTypeModal}
                onClose={handleSearchTypeModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب کنید */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSearchTypeModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>
                    <Button className="inputs-container border-0"
                        sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#E8E5FE!important', py: 1, px: 2 }}
                        onClick={() => {
                            setSearchTypeHandle('SearchType', 'Sale')
                        }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'Rent')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FAF3C0!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>رهن و اجاره</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'Exchange')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FFCAA1!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>معاوضه</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'SalePreSale')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#D6ECD2!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>پیش خرید</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'Associate')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#BDECF3!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>مشارکت</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                </Box>
            </Dialog>

            {
                openZoneModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openZoneModal}
                    onClose={handleZoneModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            <IconButton autoFocus color="inherit" onClick={handleClickTypeZone}>
                                <SettingIcon />
                            </IconButton>
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب محدوده
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleZoneModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 120px)!important", overflow: 'auto' }} id="areas-container">
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                            <InputBase placeholder='محدوده یا محله مورد نظر خود را وارد کنید' className='flex-1' onChange={areasSearchHandle} />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>

                                {
                                    areasItems && areasItems.length > 0 ?
                                        areasItems.map((item, index) => (
                                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" onChange={PropertyAreaHandle} />
                                                <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100'>
                                                    <span className="flex-1">{item.Name}</span>
                                                </label>
                                            </Grid>
                                        ))
                                        : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                }
                                {
                                    areasLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                                }
                            </Grid>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleZoneModalClose}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>
            }

            {
                openTypeZone && <Dialog className="dialog-box"
                    fullScreen
                    open={openTypeZone}
                    onClose={handleOpenTypeZoneClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            {/* <IconButton>
                <SettingIcon />
            </IconButton> */}
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>

                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleOpenTypeZoneClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                    save
                </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                        <Box>
                            <input type="radio" name='propType' id="myOptions" className="d-none typeCheck" checked={typeZone == "1"} value="موارد خودم" onChange={() => setTypeZone("1")} />
                            <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                                <PersonList />
                                موارد خودم
                            </label>
                        </Box>
                        <Box>
                            <input type="radio" name='propType' id="daryafti" className="d-none typeCheck" checked={typeZone == "2"} value="موارد دریافتی از پایش" onChange={() => setTypeZone("2")} />
                            <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                                <DownloadIcon />
                                موارد دریافتی از پایش
                            </label>
                        </Box>
                    </Box>
                    <Button className='green-btn' onClick={handleOpenTypeZoneClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
                </Dialog>
            }
        </>
    );
}

export default Filing;